import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { designNumbers } from '../data';
import { sendIframeHeight } from '../utils/iframePostMessage';

const withoutName = ['basketball', 'hockey', 'rugby', 'greek'];

const JerseyType = ({ nextStep, formData, handleChange }) => {
  const [greekSport, setGreekSport] = useState('');

  const handleSelectJerseyType = type => {
    let jerseyType = type;
    if (formData.sport === 'greek' && !greekSport) {
      setGreekSport(jerseyType);
      sendIframeHeight();
      return;
    } else if (formData.sport === 'greek') {
      jerseyType = `${greekSport}-${type}`;
    }

    handleChange({ jerseyType });
    nextStep();
  };

  const sportObject = () => {
    if (!!greekSport.length) {
      return designNumbers[formData.sport][greekSport];
    }
    return designNumbers[formData.sport];
  };

  const handleSkipToUploadDesigns = () => {
    nextStep(7);
  };

  return (
    <StyledFormStep
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Select Jersey type</h2>

      <div className="row">
        {Object.keys(sportObject()).map(type => (
          <div
            className="jersey-type-container"
            key={type}
            onClick={() => handleSelectJerseyType(type)}
          >
            <motion.img
              src={`https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto,w_400/${
                greekSport ? `greek/${greekSport}` : formData.sport
              }/type/${type}`}
              alt={`${type} jersey type`}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 1.1 }}
            />
            {(!!greekSport || !withoutName.includes(formData.sport)) && (
              <h3 className={formData.sport}>{type.split('_').join(' ')}</h3>
            )}
            {designNumbers[formData.sport][type]?.msrp && (
              <p className="msrp">
                MSRP ${designNumbers[formData.sport][type].msrp}
              </p>
            )}

          </div>
        ))}
        <div className="jersey-type-container">
          <UploadDesignsButton onClick={handleSkipToUploadDesigns}>
            <img src="upload-designs.png" alt="Upload Designs" />
          </UploadDesignsButton>
        </div>
      </div>
    </StyledFormStep>
  );
};

const UploadDesignsButton = styled.button`
  background-color: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
  width: 200px;

  img {
    width: 100%;
  }
`;

const StyledFormStep = styled(motion.div)`
  width: 100%;
  padding: 50px 20px 100px;
  overflow-y: hidden;

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 2rem 0;
    gap: 40px;
    overflow-y: hidden;
    flex: 1;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    .jersey-type-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      margin-bottom: 1rem;
      max-width: 60%;

      img {
        width: 250px;
      }

      h3 {
        position: absolute;
        top: 35%;
        background-color: #c9040399;
        color: #fff;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
        padding: 0.5rem;
        pointer-events: none;
        font-size: 2rem;

        &.soccer {
          background-color: #0d09ba99;
        }
      }

      .msrp {
        position: absolute;
        top: 90%;
        color: var(--red);
      }

      @media (max-width: 550px) {
        margin: 0 20px;

        img {
          width: 100%;
        }

        h3 {
          top: 32%;
        }
      }
    }
  }
`;

export default JerseyType;
